#@import Booking.Presenters.Base
#@export Booking.Presenters.PickerNotice

class Booking.Presenters.PickerNotice extends Booking.Presenters.Base

  toHash: ->
    notice: @getI18n().t "js.modules.booking.picker_notice.#{@options.notice}"
